import html2canvas from 'html2canvas'

export function downloadCsv(filename: string, rows: string[][]): void {
	const escape = (cell: string) => {
		if (/[",\n]/.test(cell)) return `"${cell.replace(/"/g, '""')}"`
		return cell
	}
	const body = rows.map((row) => row.map((cell) => escape(String(cell ?? ''))).join(',')).join('\n')
	const blob = new Blob([body], { type: 'text/csv;charset=utf-8' })
	const url = URL.createObjectURL(blob)
	const link = document.createElement('a')
	link.href = url
	link.download = filename
	link.click()
	URL.revokeObjectURL(url)
}

export async function captureElementAsPng(element: HTMLElement, filename: string): Promise<void> {
	const canvas = await html2canvas(element, {
		backgroundColor: getComputedStyle(element).backgroundColor || '#ffffff',
		scale: 2,
		useCORS: true,
	})
	const url = canvas.toDataURL('image/png')
	const link = document.createElement('a')
	link.href = url
	link.download = filename
	link.click()
}
